




























import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import Icon from '@/components/Icon.vue'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import AlertPostponeModal from './AlertPostponeModal.vue'
import AlertIgnoreModal from './AlertIgnoreModal.vue'
import AlertLookIntoModal from './AlertLookIntoModal.vue'
import { EAlertTypePriority } from '@zunta/configurations'

@Component({
  props: {
    alert: {
      type: Object,
      required: true
    }
  },
  components: {
    Icon,
    DateTimeLabel,
    AlertIgnoreModal,
    AlertLookIntoModal,
    AlertPostponeModal
  }
})
export default class Alert extends Vue {
  isWantPostpone: boolean = false;
  isWantIgnore: boolean = false;
  isWantLookInto: boolean = false;
  EAlertTypePriority: any = EAlertTypePriority;

  getToolTipLabel () {
    switch (this.$props.alert.alertType.priority) {
      case EAlertTypePriority.LOW:
        return 'Not Important'
      case EAlertTypePriority.MEDIUM:
        return 'Medium Priority'
      case EAlertTypePriority.HIGH:
        return 'Very Important'
    }
  }
}
